var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodelabs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9EDF1"
    },
    d: "M451.952,468.32H60.048C27.024,468.32,0,441.296,0,408.272V103.728 C0,70.704,27.024,43.68,60.048,43.68h391.896c33.032,0,60.056,27.024,60.056,60.048v304.544 C512,441.296,484.976,468.32,451.952,468.32z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512,138.184v-34.456c0-33.032-27.024-60.048-60.048-60.048H60.048C27.024,43.68,0,70.704,0,103.728v34.456L512,138.184 L512,138.184z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FC6F58"
    },
    cx: 58.4,
    cy: 90.928,
    r: 13.424
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49C3E8"
    },
    cx: 96.64,
    cy: 90.928,
    r: 13.424
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD160"
    },
    cx: 134.904,
    cy: 90.928,
    r: 13.424
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 429.392,
    y: 87.168,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.416,
    height: 6.824
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "450.872,111.08 445.728,106.6 459.376,90.928 445.728,75.256 450.872,70.776  468.448,90.928  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M379.264,112.296H208.336c-11.752,0-21.368-9.616-21.368-21.368l0,0 c0-11.752,9.616-21.368,21.368-21.368h170.928c11.752,0,21.368,9.616,21.368,21.368l0,0 C400.632,102.68,391.016,112.296,379.264,112.296z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.656,101.16l-4.704-19.24h3.744l1.824,8.736c0.48,2.344,0.936,4.8,1.256,6.704h0.056c0.32-2.024,0.856-4.304,1.4-6.736 l2.08-8.704h3.68l1.92,8.856c0.48,2.28,0.88,4.424,1.16,6.504h0.064c0.336-2.12,0.8-4.304,1.304-6.656l2-8.704h3.576l-5.176,19.24 h-3.76l-2-9.056c-0.496-2.184-0.824-4.016-1.056-6.104h-0.064c-0.336,2.056-0.704,3.92-1.28,6.104l-2.224,9.056H212.656z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.712,101.16l-4.704-19.24h3.744l1.824,8.736c0.48,2.344,0.936,4.8,1.256,6.704h0.056c0.32-2.024,0.856-4.304,1.4-6.736 l2.08-8.704h3.68l1.92,8.856c0.48,2.28,0.88,4.424,1.16,6.504h0.064c0.336-2.12,0.8-4.304,1.304-6.656l2-8.704h3.576l-5.176,19.24 h-3.76l-2-9.056c-0.496-2.184-0.824-4.016-1.056-6.104h-0.064c-0.336,2.056-0.704,3.92-1.28,6.104l-2.224,9.056H237.712z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262.768,101.16l-4.704-19.24h3.744l1.824,8.736c0.48,2.344,0.936,4.8,1.256,6.704h0.056c0.32-2.024,0.856-4.304,1.4-6.736 l2.08-8.704h3.68l1.92,8.856c0.48,2.28,0.88,4.424,1.16,6.504h0.064c0.336-2.12,0.8-4.304,1.304-6.656l2-8.704h3.576l-5.176,19.24 h-3.76l-2-9.056c-0.496-2.184-0.824-4.016-1.056-6.104h-0.064c-0.336,2.056-0.704,3.92-1.28,6.104l-2.224,9.056H262.768z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M282.064,99.208c0-1.304,0.92-2.256,2.176-2.256c1.28,0,2.176,0.92,2.176,2.256c0,1.296-0.864,2.264-2.176,2.264 C282.96,101.48,282.064,100.504,282.064,99.208z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M67.408,301.424l128.504-59.704v28.376l-97.184,42.568v0.536l97.184,42.568v28.376L67.408,324.456 V301.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M215.76,394.864l57.296-194.104h27.04L242.8,394.864H215.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M444.144,325.248L315.64,384.152v-28.376l99.328-42.568v-0.536l-99.328-42.568v-28.376 l128.504,58.904V325.248z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodelabs);
export default __webpack_public_path__ + "static/media/codelabs.88ffebe68ab522a564666fa3e1e8ab7e.svg";
export { ForwardRef as ReactComponent };